import styled from 'styled-components';
import { motion } from 'framer-motion';

import { typography } from '@theme/font';
import { media } from '@theme/media';

import Time from '../../../assets/images/icon-time.svg';

export const TimeIcon = styled(Time)`
  display: block;
  margin: 0 auto 4px;
`;

export const OfferedInDesktopContainer = styled.div`
  display: none;
  ${media.mobile} {
    display: block;
  }
`;

export const Container = styled.div`
  ${typography({})};
  position: relative;
  padding: 12px 0;
`;

export const BulletPoints = styled.ul`
  list-style: none;
  margin: 0 0 0 -8px;
  padding: 0;
`;

export const Bullet = styled.li`
  position: relative;
  padding-left: 8px;

  &:before {
    content: '\\00B7';
    position: absolute;
    left: 0;
  }
`;

export const DescriptionLink = styled.span`
  margin-left: 4px;
  transition: transform 0.2s ease-in-out;
  transform: translateX(0);
  display: inline-block;
`;

export const LinkCopy = styled.span`
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

export const Description = styled.p`
  margin: 0;
  padding: 0 0 12px;
  cursor: pointer;

  &:hover {
    ${DescriptionLink} {
      transform: translateX(5px);
    }

    ${LinkCopy} {
      opacity: 1;
    }
  }
`;

export const Thumbnail = styled.img`
  width: 100%;
  display: block;
  cursor: pointer;
`;

export const MotionContainer = styled(motion.div)`
  position: absolute;
  width: 100%;
`;
